import { CardCanvas } from '@qpr/components';
import { Location } from 'history';
import React, { useContext, useEffect } from 'react';
import { match as MatchProps } from 'react-router-dom';
import AppBarContext from '../components/BusinessPortalAppBarContext';

export interface IntermediatePageBuilderProps {
  match: MatchProps;
  location?: Location;
}

const IntermediatePage = ({ match }: IntermediatePageBuilderProps) => {
  const appBarContext = useContext(AppBarContext);

  useEffect(() => {
    appBarContext.setAppBar(true);
    appBarContext.setPeriodSelector(false);
  }, [appBarContext]);

  const tenantSymbolFromMatch = match.url.split('/')[1];
  const pathFromMatch = match.url.split('/').slice(2);

  return <CardCanvas tenantSymbol={tenantSymbolFromMatch} path={pathFromMatch} />;
};

export default IntermediatePage;
